export interface TypeAsnIncome {
  typeAsnIncomeId: number
  name: string
}

export enum EnumTypeAsnIncome {
  Fulfillment = 1,
  Reverse = 2,
  Undeliverable = 3,
  Restock = 4
}
